import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess';
import { useCallIntelFeatureAccess } from '@frontend/call-intel-core';
import { useCallIntelNotification } from '@frontend/notifications';
import { GetWeavePopNotificationByType } from '@frontend/types';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useCallIntelUnhappyCallEventSubscription = () => {
  const { create } = useCallIntelNotification();

  const { isAccessible } = useCallIntelFeatureAccess({
    permissions: [Permission.CALL_CLASSIFICATION_READ],
    featureFlagKey: 'enable-unhappy-call-notification-backend',
  });

  return useWebsocketEventSubscription(NotificationType.CALL_INTELLIGENCE_UNHAPPY_CALL, (payload) => {
    const notification = {
      id: payload.id,
      timestamp: Date.now(),
      type: 'unhappy-call',
      payload: {
        callId: payload.params.callId,
        locationId: payload.params.locationId,
        categories: payload.params.categories,
        person: payload.params.person,
        phoneNumber: payload.params.phoneNumber,
        startTime: payload.params.startTime,
      },
      state: {
        paused: false,
        status: 'unread',
      },
    } satisfies GetWeavePopNotificationByType<'unhappy-call'>;

    if (isAccessible) {
      create(notification);
    }
  });
};
